const Cambios = () => {
  return (
    <p>
      Si deseás realizar un cambio envía un mail a{" "}
      <strong>info@vanyaychicago.com.ar</strong> contando los motivos del mismo.
      • Tienes un plazo máximo de <strong>30 días corridos</strong> de recibida
      la compra para efectuar el cambio{" "}
      <strong>(sujeto a disponibilidad)</strong>
      .• Deberá realizarse por artículos que correspondan a la misma temporada,
      sin excepción.• Los productos deberán encontrarse en el mismo estado en el
      que fueron enviados o recibidos. • En el caso de que la prenda enviada no
      haya sido la correcta o tenga alguna falla, el cambio es sin cargo.• Si el
      cambio es solicitado por otra prenda o talle, Vanya y Chicago bonifica un
      tramo del cambio. El otro será abonado por el cliente. Opcionalmente,
      pueden dirigirse al showroom para realizar el cambio sin costo.
      Recomendamos consultar disponibilidad por mail previamente.• Los cambios
      via correo, deben despacharse en la sucursal mas cercana de Correo
      Argentino y luego llegan a su domicilio • Si hay una diferencia a favor
      del cliente, se podrá usar como parte de pago de otro producto o bien
      quedará a cuenta.Si la diferencia es a favor de la marca, el cliente
      deberá abonarla para poder enviarle el producto.•{" "}
      <strong>
        Todos los productos en sale son ventas finales. No tienen cambio ni
        devolución.
      </strong>
    </p>
  );
};

export default Cambios;
